(function () {
  if (window.__vesaKauftipp) return;
  window.__vesaKauftipp = true;

  function auswahl() {
    try { return JSON.parse(localStorage.getItem('3idee_auswahl') || 'null') || {}; } catch (e) { return {}; }
  }
  function proxy() { return (window.FinderClean && window.FinderClean.proxy) || '/apps/monitor-db'; }
  function abruf(url) {
    if (window.EngineStatus) return window.EngineStatus.hol(url);
    return fetch(url).then(function (r) { return r.json(); });
  }
  function sku(c) { return (c && (c.sku || (c.product && c.product.shopify_sku))) || ''; }

  function karteWaehlen(box, karte) {
    box.querySelectorAll('.sku__karte').forEach(function (k) {
      var an = k === karte;
      k.classList.toggle('sku__karte--an', an);
      k.setAttribute('aria-checked', an ? 'true' : 'false');
    });
  }

  function stand(box, passend) {
    box.__geprueft = !!passend;
    var frage = box.querySelector('[data-vkt-frage]');
    if (frage && passend) frage.hidden = true;
    if (passend) { var m0 = box.querySelector('[data-vkt-marke]'); if (m0) m0.hidden = false; }
    var marke = box.querySelector('[data-vkt-marke]');
    if (!box.__ungeprueftHtml && marke) box.__ungeprueftHtml = marke.innerHTML;
    var sichtbar = 0;
    box.querySelectorAll('[data-vkt-karte]').forEach(function (k) {
      k.hidden = !!passend && !passend.hasOwnProperty(k.getAttribute('data-vkt-karte'));
      if (!k.hidden) sichtbar++;
    });
    box.hidden = !!passend && !sichtbar;
    if (marke) {
      var vf = box.querySelector('template[data-vkt-vf]');
      marke.innerHTML = passend ? (vf ? vf.innerHTML : '') : (box.__ungeprueftHtml || '');
    }
    if (!box.querySelector('.sku__karte--an:not([hidden])')) {
      var erste = box.querySelector('[data-vkt-karte]:not([hidden])');
      if (erste) karteWaehlen(box, erste);
    }
  }

  function lautWerden(box) {
    if (box.__geprueft) return;
    var frage = box.querySelector('[data-vkt-frage]');
    var marke = box.querySelector('[data-vkt-marke]');
    if (frage) frage.hidden = false;
    if (marke) marke.hidden = true;
  }

  function pruefen(box) {
    var a = auswahl();
    var refs = (a.refs || []).map(String).filter(Boolean);
    if (!refs.length) { stand(box, null); return; }
    var min = Number(box.getAttribute('data-vkt-min')) || 1;
    var n = Math.min(4, Math.max(min, Number(a.anzahl) || refs.length));
    var m = [];
    for (var i = 0; i < n; i++) m.push('m=' + encodeURIComponent(refs[i % refs.length]));
    var urteil = window.SetupUrteil ? window.SetupUrteil.hole().catch(function () { return null; }) : Promise.resolve(null);
    Promise.all([abruf(proxy() + '/combinations/compatible?' + m.join('&') + '&mount_type=tischhalterung'), urteil]).then(function (b) {
      var j = b[0], st = b[1];
      var d = (j && j.data) || j || {};
      var passend = {};
      var allein = !(st && !st.ausfall && (st.monitore || []).some(function (x) { return x.fall !== 'ok' || x.adapter; }));
      if (allein) (d.combinations || []).forEach(function (c) {
        if (sku(c) && (c.fit || 'direct') === 'direct' && !(c.requires || []).length) passend[sku(c)] = true;
      });
      stand(box, passend);
    }).catch(function () { stand(box, null); });
  }

  function einrichten(box) {
    if (box.__vkt) return;
    box.__vkt = true;

    box.addEventListener('click', function (e) {
      var mini = e.target.closest('[data-vkt-mini]');
      if (mini) {
        e.preventDefault();
        var ev = new CustomEvent('3idee:mini-pdp', {
          bubbles: true, cancelable: true,
          detail: { handle: mini.getAttribute('data-vkt-mini'), gepruft: box.__geprueft === true }
        });
        document.dispatchEvent(ev);
        if (!ev.defaultPrevented) window.location.href = mini.getAttribute('data-vkt-url');
        return;
      }
      var knopf = e.target.closest('[data-vkt-kaufen]');
      if (knopf) {
        var karte = box.querySelector('.sku__karte--an:not([hidden])');
        if (!karte || !window.WarenkorbLegen) return;
        lautWerden(box);
        knopf.disabled = true;
        window.WarenkorbLegen([{ id: Number(karte.getAttribute('data-vkt-variante')), quantity: 1 }], function () {
          knopf.disabled = false;
        });
        return;
      }
      if (e.target.closest('a, button')) return;
      var k = e.target.closest('.sku__karte');
      if (k) { karteWaehlen(box, k); lautWerden(box); }
    });
    box.addEventListener('keydown', function (e) {
      var k = e.target.closest && e.target.closest('.sku__karte');
      if (!k || e.target !== k || (e.key !== 'Enter' && e.key !== ' ')) return;
      e.preventDefault();
      karteWaehlen(box, k);
      lautWerden(box);
    });

    pruefen(box);
  }

  function lauf() { document.querySelectorAll('[data-vkt]').forEach(einrichten); }
  function neu() { document.querySelectorAll('[data-vkt]').forEach(pruefen); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lauf);
  else lauf();
  document.addEventListener('finder:auswahl', neu);
  window.addEventListener('storage', function (e) { if (e.key === '3idee_auswahl') neu(); });
})();
